import { useContext, useEffect } from 'react';
import { useQuery } from '@apollo/client/react';

import { GET_WORK_ORDER_TEMPLATE } from '@atom/graph/workTemplate';
import { Progress } from '@atom/mui';
import { templateTaskToTask } from '@atom/utilities/taskUtilities';

import BulkContext, { buildTabs, Tab } from '../BulkContext';

import Step from './Step';

import classes from './formView.module.css';

const FormView = () => {
  const {
    tab,
    workOrder,
    setWorkOrder,
    workTemplate,
    workTemplateType,
    setWorkTemplateType,
  } = useContext(BulkContext);

  const { data, loading } = useQuery(GET_WORK_ORDER_TEMPLATE, {
    variables: { id: workTemplate?.id },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (data?.workOrderTemplate) {
      const { workOrderTemplate } = data;
      setWorkTemplateType(workOrderTemplate);

      // Initialize the new work order tasks:
      const tasks = templateTaskToTask(workOrderTemplate.tasks);
      const { fieldOrder, fields, summary } = workOrderTemplate;

      const newWorkOrder = { ...workOrder, fieldOrder, fields, summary, tasks };
      setWorkOrder(newWorkOrder);
    }
  }, [data]);

  if (loading || !workTemplateType) {
    return (
      <div className={classes.formSpinner}>
        <Progress />
      </div>
    );
  }

  const tabs = buildTabs(workTemplateType.tasks);

  return (
    <div className={classes.formContainer}>
      <div className={classes.formContent}>
        <div className={classes.formStepper}>
          {tabs.map((tabItem: Tab) => (
            <Step tab={tabItem} currentTab={tab} />
          ))}
        </div>
        <tab.body tab={tab} />
      </div>
    </div>
  );
};

export default FormView;
